import React from "react";
import { MainDiv } from "../../components/Profile/Profile.style";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";
import VolunteerPROTable from "../../components/Volunteer/VolunteerPROTable";

const VolunteerPROPage = () => {
  return (
    <MainDiv>
      <VolunteerHeading>Volunteer PRO Form</VolunteerHeading>
      <VolunteerPROTable></VolunteerPROTable>
    </MainDiv>
  );
};

export default VolunteerPROPage;
